import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { ICardAssignees } from 'api/queries/getCardAssignees.query';

import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import classes from 'components/common/GlobalFiltersInPage/components/wbsLevelFilter/WbsLevelFilter.module.scss';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';
import Slider from 'components/common/Slider/Slider';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string;
    options?: ICardAssignees[];
    isSelected?: boolean;
}

export const WbsLevelFilter = ({ name, methods, filtersStatusRef, handleFilters, value, isSelected = true }: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const wbsLevelLabelFormat = (value) => {
        return <div>{value === 10 ? `${value}+` : value}</div>;
    };

    const getValue = (value) => {
        if (!value || value.length === 0) {
            return [0, 10];
        }
        return value;
    };

    return isSelected ? (
        <div className={classes.wbsLevelWrapper}>
            <span className={classes.title}>WBS Level</span>
            <div data-testid={'battlecards-filters-wbslevel-slider'} className={classes.sliderWrapper}>
                <Controller
                    render={({ field }) => (
                        <Slider
                            id={'battlecards-filters-wbslevel-slider'}
                            {...field}
                            value={getValue(value)}
                            step={1}
                            min={1}
                            max={10}
                            valueLabelDisplay={'on'}
                            onChangeCommitted={(_e, value) => {
                                methods?.setValue(name, value);
                                handleFilters?.();
                            }}
                            valueLabelFormat={wbsLevelLabelFormat}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />
            </div>
        </div>
    ) : null;
};
